// SEO component utilisant le support natif des tags <head> de React 19
// (react-helmet-async est incompatible avec React 19)

const SITE_NAME = "Tsitsok Michel Berger";
const DEFAULT_DESCRIPTION = "Ingénieur Logiciel Senior & Consultant. Portfolio, Blog et Services de développement web et mobile.";
const DEFAULT_IMAGE = "/photos/michel-suit.jpg";
const SITE_URL = process.env.REACT_APP_SITE_URL || "https://micheltsitsok.com";

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  image,
  url,
  type = "website",
  author,
  publishedTime,
  tags = [],
}) => {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const pageImage = image || DEFAULT_IMAGE;
  const pageUrl = url || SITE_URL;

  const fullImageUrl = pageImage.startsWith("http")
    ? pageImage
    : `${SITE_URL}${pageImage}`;

  return (
    <>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      {tags.length > 0 && <meta name="keywords" content={tags.join(", ")} />}
      <link rel="canonical" href={pageUrl} />

      {/* OpenGraph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={fullImageUrl} />

      {/* Article-specific */}
      {type === "article" && author && (
        <meta property="article:author" content={author} />
      )}
      {type === "article" && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {type === "article" &&
        tags.map((tag, index) => (
          <meta key={index} property="article:tag" content={tag} />
        ))}
    </>
  );
};

export default SEO;
